"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var epoch = 1560000000000; //This is pretty much the time wrote Rhyhtm City, give or take a few seconds.  Weird huh?

function generateNewId() {
  var randomPart = Math.random().toString(36).substr(2, 6);
  var timePart = (new Date().valueOf() - epoch).toString(36);
  return timePart + randomPart;
}

exports.generateNewId = generateNewId;

function cleanGuid(guid) {
  return guid.replace('-', '');
}

exports.cleanGuid = cleanGuid;

function removeRegionFromUserId(userId) {
  return userId.split(':')[1];
}

exports.removeRegionFromUserId = removeRegionFromUserId;